import React, { useEffect, useState } from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { api } from "../../api";
import { Helmet } from "react-helmet-async";
import { AppLoadingScreen } from "../AppLoadingScreen";

const UseStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      // color: theme.palette.text.secondary,
    },
  })
);

export const PosServiceNotification = () => {
  const classes = UseStyles();
  const [posServiceNotification, setPosServiceNotification] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    try {
      const interval = setInterval(async () => {
        const notificationResult = await api.get(
          `notification//terminal-services-status`
        );
        if (notificationResult !== undefined) {
          setPosServiceNotification(notificationResult);
          setIsLoading(false);
        }
      }, 10000);
      return () => clearInterval(interval);
    } catch (e) {
      console.log("error", e);
    }
  });

  return (
    <>
      <Helmet>
        <title>Pos services</title>
      </Helmet>
      <div>
        {isLoading === true ? (
          <AppLoadingScreen />
        ) : (
          <div>
            <h1>Pos Services</h1>
            <Grid container spacing={3}>
              {posServiceNotification.map((i: any) => (
                <Grid item xs={6}>
                  <Paper
                    className={classes.paper}
                    style={{ backgroundColor: "#dcdcdc" }}
                  >
                    <Typography
                      style={{
                        fontSize: "21px",
                        color: "black",
                      }}
                    >
                      {i.terminal_name}
                    </Typography>
                    <Grid
                      container
                      spacing={3}
                      justify="center"
                      style={{ paddingTop: "2em" }}
                    >
                      {i.services.map((j: any) => (
                        <Grid item xs={6}>
                          <Paper className={classes.paper}>
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <Typography>{j.service_disp_name}</Typography>
                              </Grid>
                              <Grid item xs={1}></Grid>
                              <Grid
                                item
                                xs={5}
                                style={{
                                  backgroundColor:
                                    j.error === true
                                      ? "#e01b1b"
                                      : j.idle === true
                                      ? "#e01b1b"
                                      : "green",

                                  color: "white",
                                }}
                              >
                                <Typography>
                                  {j.error === true
                                    ? "Error"
                                    : j.idle === true
                                    ? "Idle State"
                                    : j.status}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </div>
        )}
      </div>
    </>
  );
};
